import { PostStatus } from '../enums';

export interface Post {
  id: string;
  authorId: string;
  context: string;
  type: string;
  content: string;
  linkUrl: string | null;
  mediaKey: string | null;
  mediaUrl: string | null;
  pollData: unknown;
  status: PostStatus;
  createdAt: Date;
  updatedAt: Date;
}
